export interface BioFormData {
  updated_profile_url: string;
  profile_image_url: string;
  banner_image_url: string;
  bio: string;
  gsi4pk: string;
  publicly_displayed_name: string;
  user_name: string;
  is_creator: boolean;
  first_name: string;
  last_name: string;
  social_handles: {
    platform: string;
    name: string;
    icon: string;
    username: string;
    url: string;
  }[];
  default?: boolean; // Add the default property
}

export interface BioProductItem {
  value: {
    sk?: string;
    pk?: string;
    product_type?: string;
    action_type: string;
    gsi2pk?: string;
    gsi2sk?: string;
    image?: string;
    title?: string;
    org_title?: string;
    price?: string;
    from?: string;
    name?: string;
    url?: string;
    iconClass?: string;
    post_type?: string;
    id?: string;
    type?: string;
    isIndividual?: boolean;
    portfolioSk?: string;
    event_name?: string;
    event_date?: string;
    event_time?: string;
    timezone?: string;
    venue_name?: string;
    city?: string;
    state?: string;
    country?: string;
  };
}

export const BIO_ACTION_TYPES = {
  SPECIFIC_ITEM: 'specific_item',
  GENERAL_ACTION: 'general_action',
  EXTERNAL_ACTION: 'external_action',
  SPECIFIC_FEED_CONTENT: 'specific_feed_content',
  SPECIFIC_PORTFOLIO: 'specific_portfolio',
  SPECIFIC_EVENT_TICKETING: 'specific_event_ticketing',
};

export const BIO_PRODUCT_PREFIXES = {
  USER: '#USER',
  HASH: '#',
};

export const BIO_URL_SEGMENTS = {
  DASHBOARD_MERCHANDISE_DETAIL: 'dashboard/merchandise-detail',
  DASHBOARD_MERCHANDISE_DETAILS: 'dashboard/merchandise-details',
  DOWNLOADABLE: 'downloadable',
  DOWNLOADABLES_UPPER: 'DOWNLOADABLES',
  STORE: 'store',
  VIEW_TICKET: 'View Ticket',
};

export const IMAGE_TYPES = {
  PROFILE_IMAGE: 'profileImage',
  PROFILE_BANNER: 'profileBanner',
};

export const GENERAL_ACTION_ITEMS = ['welcome_video'];

export const LINK_IN_BIO_MESSAGES = {
  POWERED_BY_TOPFANS: 'Powered By',
  GET_YOUR_OWN_PLATFORM: 'Get Your Own Platform',
  TOPFANS_URL: 'https://www.topfans.com/',
  REFERRAL_LINK: 'Referral Link',
};